import { updateRelation } from 'modules/Profile/redux/relations/actions';
import { connect } from 'react-redux';
import GuardiansList from './GuardiansList';

const mapDispatchToProps = {
  updateRelation,
};

export default connect(null, mapDispatchToProps)(GuardiansList);
